interface Props {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const Paginacao: React.FC<Props> = ({
  page,
  totalPages,
  onPageChange,
}) => {
  if (totalPages <= 0) return null;

  return (
    <div className="flex justify-center gap-2 mt-4">
      <button
        disabled={page === 1}
        onClick={() => onPageChange(page - 1)}
        className="px-3 py-1 border rounded disabled:opacity-50"
      >
        Anterior
      </button>

      <span className="px-3 py-1 text-sm">
        Página {page} de {totalPages}
      </span>

      <button
        disabled={page === totalPages}
        onClick={() => onPageChange(page + 1)}
        className="px-3 py-1 border rounded disabled:opacity-50"
      >
        Próxima
      </button>
    </div>
  );
};

export default Paginacao;
